module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" Copyright © 2014 by James Carroll")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "px0"
    }
  }), _vm._v(" All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The Library of Congress has cataloged the print edition as follows:"), _c('br'), _vm._v("\nCarroll, James, date."), _c('br'), _vm._v("\nWarburg in Rome / James Carroll.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-73890-1 (hardback)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("1. World War, 1939–1945—Jews—Rescue—Fiction. 2. World War, 1939–1945—Civilian relief—Fiction. 3. Rescue work—Europe—History—20th century—Fiction. 4. War relief—Europe—History—20th century—Fiction. 5. Rome—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("PS")]), _vm._v("3553."), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("A")]), _vm._v("764"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("W")]), _vm._v("37 2014")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("813'.54—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("2013046582")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("e"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-73895-6"), _c('br'), _vm._v("\nv1.0714")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0